<div class="deployment-stage deployment-stage--{{ stage().status }}" data-testid="deployment-stage">
  <div class="deployment-stage__head">
    <span class="deployment-stage__name" data-testid="deployment-stage-name">{{ stage().name }}</span>
    <span class="deployment-stage__dot" data-testid="deployment-stage-dot" aria-hidden="true"></span>
    <span class="sr-only">{{ 'liveDashboard.devops.pipeline.status.' + stage().status | translate }}</span>
  </div>
  <div class="deployment-stage__version" data-testid="deployment-stage-version">{{ stage().version }}</div>
  <div class="deployment-stage__when" data-testid="deployment-stage-when">{{ stage().when }}</div>
</div>
